<template>
  <div
    :class="`bcc-input ${isError ? 'is-error' : ''} ${
      disabled ? 'disabled' : ''
    }`"
  >
    <input
      v-if="type !== 'textarea'"
      :type="type"
      class="bcc-input-inner input"
      :placeholder="placeholder"
      v-model="val"
      spellcheck="false"
      :maxlength="maxlength"
      :minlength="minlength"
      :disabled="disabled"
      @blur="blur"
    />
    <textarea
      v-else
      class="bcc-input-inner textarea"
      :placeholder="placeholder"
      v-model="val"
      spellcheck="false"
      :rows="rows"
      :maxlength="maxlength"
      :minlength="minlength"
      :disabled="disabled"
      @blur="blur"
    ></textarea>
    <div v-if="showWordLimit" class="word-limit">
      {{ `${val.toString().length}/${this.maxlength}` }}
    </div>
  </div>
</template>
<script>
import Emitter from '../../mixins/emitter'

export default {
  name: 'BccInput',
  componentName: 'BccInput',
  data () {
    return {
      val: this.value
    }
  },
  mixins: [Emitter],
  props: {
    value: {
      default: ''
    },
    placeholder: String,
    autocomplete: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: 'text'
    },
    rows: {
      type: String | Number,
      default: 5
    },
    isError: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String | Number,
      default: 999
    },
    minlength: {
      type: String | Number,
      default: 0
    },
    showWordLimit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (val) {
      this.val = val
    },
    val (val) {
      this.$emit('input', val)
      this.$emit('change', val)
    }
  },
  methods: {
    blur () {
      this.$emit('blur')
      this.dispatch('BccFormItem', 'bcc.form.blur', [this])
    }
  }
}
</script>
